import React from 'react';
import { Search, X } from 'lucide-react';
import styles from './FilterBar.module.scss';
import { BackofficeFilters } from '../../../../types/backoffice.ts';

interface FilterBarProps {
  filters: BackofficeFilters;
  onFilterChange: (filters: Partial<BackofficeFilters>) => void;
}

const FilterBar: React.FC<FilterBarProps> = ({ filters, onFilterChange }) => {
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onFilterChange({ searchTerm: e.target.value });
  };

  const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onFilterChange({ status: e.target.value as any });
  };

  const handleClearFilters = () => {
    onFilterChange({
      searchTerm: '',
      status: 'all',
      minBudget: null,
      maxBudget: null,
      dateFrom: null,
      dateTo: null,
      categoryId: null
    });
  };

  const hasActiveFilters = filters.searchTerm || filters.status !== 'all';

  return (
    <div className={styles.filterBar}>
      <div className={styles.searchBox}>
        <Search size={16} className={styles.searchIcon} />
        <input
          type="text"
          placeholder="Buscar por nombre del proyecto..."
          value={filters.searchTerm}
          onChange={handleSearchChange}
          className={styles.searchInput}
        />
      </div>

      <select
        value={filters.status}
        onChange={handleStatusChange}
        className={styles.select}
      >
        <option value="all">Todos los estados</option>
        <option value="sin-estado">Sin estado</option>
        <option value="pending">Pendientes</option>
        <option value="approved">Aprobados</option>
        <option value="refused">Rechazados</option>
      </select>

      {hasActiveFilters && (
        <button onClick={handleClearFilters} className={styles.clearButton}>
          <X size={16} />
          Limpiar filtros
        </button>
      )}
    </div>
  );
};

export default FilterBar;

